import "./userProfile.css";
import { DialogActions } from "@mui/material";
import { PointObjectInfo } from "../../Interface/user.interface";
import PointsExpDialog from "../PointsExpDialog/pointsExpDialog";

interface UserProfileProp {
    userId: string;
    point: number;
    fullName: string;
    pointInfo: PointObjectInfo[];
}

const userProfile = ({ point, fullName, pointInfo }: UserProfileProp) => {
    return (
        <div className="container user-profile">
            <div className="user-profile-canvas">
                <div className="name-title">
                    <h1>{fullName}</h1>
                </div>
                <div className="info">
                    <h4>คะแนนของคุณ</h4>
                    <h1>{Number(point).toString()} คะแนน</h1>
                    <DialogActions>
                        <PointsExpDialog pointInfo={pointInfo} />
                    </DialogActions>
                </div>
            </div>
        </div>
    );
};

export default userProfile;
